import getAPI from './getAPI.js'

export default async function getTaskFlows() {
    const data = await getAPI('taskflows');
    return data;
}
